(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-row"] && !Shopify.designMode) return;
  try {
    
  function initCollectionCardSliders() {
    document.querySelectorAll('.card-image-slider-wrapper:not(.slider-initialized)').forEach((wrapper) => {
      wrapper.classList.add('slider-initialized');
      const track = wrapper.querySelector('.card-image-slider-track');
      const prev = wrapper.querySelector('.card-slider-arrow--prev');
      const next = wrapper.querySelector('.card-slider-arrow--next');
      const dots = wrapper.querySelectorAll('.slider-dot');
      const slides = track.querySelectorAll('.card-slider-slide');
      const total = slides.length;
      let index = 0;

      if (total <= 1) return;

      function updateSlider() {
        track.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((dot, idx) => {
          if (idx === index) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      if (prev) {
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          index = (index - 1 + total) % total;
          updateSlider();
        });
      }

      if (next) {
        next.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          index = (index + 1) % total;
          updateSlider();
        });
      }

      // Touch / Swipe Gesture support for mobile
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      let isSwiping = false;

      wrapper.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length === 1) {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            touchEndX = touchStartX;
            touchEndY = touchStartY;
            isSwiping = true;
          }
        },
        { passive: true }
      );

      wrapper.addEventListener(
        'touchmove',
        function (e) {
          if (isSwiping && e.touches.length === 1) {
            touchEndX = e.touches[0].clientX;
            touchEndY = e.touches[0].clientY;
          }
        },
        { passive: true }
      );

      wrapper.addEventListener('touchend', function (e) {
        if (!isSwiping) return;
        isSwiping = false;

        const diffX = touchEndX - touchStartX;
        const diffY = touchEndY - touchStartY;

        if (Math.abs(diffX) > 30 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX < 0) {
            index = (index + 1) % total;
          } else {
            index = (index - 1 + total) % total;
          }
          updateSlider();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initCollectionCardSliders);
  document.addEventListener('shopify:section:load', initCollectionCardSliders);

  } catch(e) { console.error(e); }
})();
})();
